import Loading from '@cartwhl/ui/atoms/Loading';
import Text from '@cartwhl/ui/base/Text';
import CheckmarkIcon from '@cartwhl/ui/icons/CheckmarkIcon';
import CrossIcon from '@cartwhl/ui/icons/CrossIcon';
import Button from '@cartwhl/ui/input/Button';
import type { FilesListFile } from '@cartwhl/ui/input/FilesList';

type FileItemStatus = 'idle' | 'uploading' | 'uploaded';

interface FilesListItemProps {
  file: FilesListFile;
  removeFile: () => void;
  status: FileItemStatus;
}

export default function FilesListItem({
  file,
  removeFile,
  status,
}: FilesListItemProps) {
  return (
    <div className="group relative flex h-10 items-center gap-4 rounded-lg px-3">
      <Text
        variant="studio/body/medium/sm"
        className="text-primary flex-1 truncate"
      >
        {file.file.name}
      </Text>

      <span className="pointer-events-none flex h-6 w-6 shrink-0 items-center justify-center group-hover:opacity-0">
        {status === 'uploading' && (
          <Loading
            className="text-green h-5 w-5"
            trackClassName="stroke-gray-30"
            strokeWidth={2.5}
          />
        )}
        {status === 'uploaded' && (
          <CheckmarkIcon className="text-green-35 h-5 w-5" />
        )}
      </span>
      <Button
        onClick={removeFile}
        variant="tertiary"
        size="sm"
        className="text-secondary absolute right-0 z-1 opacity-0 transition-opacity group-hover:opacity-100"
        icon={<CrossIcon />}
      />
    </div>
  );
}
